
import { defineComponent } from 'vue';
import BarraLateral from './components/BarraLateral.vue';

export default defineComponent({
  name: 'App',
  title: 'socorro',
  components: {
    BarraLateral,
  },
  data () {
    return {
      modoEscuroAtivo: false,
    }
  },

  methods: {
    trocarTema (modoEscuro : boolean) {
      this.modoEscuroAtivo = modoEscuro;
      console.log(this.modoEscuroAtivo)
    }
  },

  mounted() {
    document.title = 'Lista'
  }
});
